
export default {
  cacheDataRowExcel ({ commit }, params) {
    commit('SAVE_DATA_TABLE_ROW_EXCEL', params)
  },

  cacheDataErrRowExcel ({ commit }, params) {
    commit('SAVE_DATA_ERR_ROW_EXCEL', params)
  },

  cacheFileNameExcel ({ commit }, params) {
    commit('SAVE_DATA_FILE_NAME_EXCEL', params)
  }

}
 